function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom';
import ReactGA from 'react-ga4';
import { LoadingSpinner } from '../../../Common/LoadingUI';
import { useDispatch, useSelector } from 'react-redux';
import BsArrowLeft from '@meronex/icons/bs/BsArrowLeft';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import useDataEventDetails from './data';
import useData from '../../data';
import Modal from '../../../Common/Modal';
import GrClose from '@meronex/icons/gr/GrClose';
import Container from '../../../Projects/Components/Container';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EventsDetails = function EventsDetails(_ref) {
  var _event$displayImage, _config$deals$darkThe, _config$events, _config$deals$darkThe2;
  var event = _ref.event,
    isLoading = _ref.isLoading,
    config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    cmsClient = _ref.cmsClient,
    Sidebar = _ref.Sidebar,
    authActions = _ref.authActions;
  var params = useParams();
  var history = useHistory();
  var clientWebview = useSelector(function (state) {
    return state.webView.clientWebview;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showUnregisteredModal = _useState2[0],
    setShowUnregisteredModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showRegisteredModal = _useState4[0],
    setShowRegisteredModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRegistered = _useState6[0],
    setIsRegistered = _useState6[1];
  var _useData = useData({
      isPast: true,
      checkProtectedEvents: false,
      winnreAuth: winnreAuth,
      cmsClient: cmsClient,
      config: config
    }),
    pastEvents = _useData.events,
    isLoadingEvents = _useData.isLoading;
  var isUserAuthenticated = useSelector(function (state) {
    return state.auth.isAuthenticated;
  });
  var internalWebview = useSelector(function (state) {
    return state.webView.internalWebview;
  });
  var userId = useSelector(function (state) {
    return state.auth.userId;
  });
  var clickThroughMobile = clientWebview || internalWebview;
  var dispatch = useDispatch();
  var userStatus = useSelector(function (state) {
    var _state$auth$userDetai;
    return (_state$auth$userDetai = state.auth.userDetails) === null || _state$auth$userDetai === void 0 ? void 0 : _state$auth$userDetai.status;
  });
  var openLoginModal = function openLoginModal() {
    if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
      dispatch(authActions.openLoginModal());
    }
  };
  var registerHandler = function registerHandler() {
    var _window;
    if (!isUserAuthenticated) {
      openLoginModal();
      return;
    }
    if (userStatus !== 'REGISTERED') {
      setShowUnregisteredModal(true);
      return;
    }
    if (cmsClient.defaults.baseURL === 'https://prod.loyalie.in' || cmsClient.defaults.baseURL === 'https://uat.loyalie.in') {
      window.fbq('trackCustom', 'EventRegistration');
    }
    ReactGA.event({
      category: 'EVENTS',
      action: 'EVENT REGISTRATION CLICKED',
      label: 'REGISTER NOW BUTTON'
    });
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track('RegisterNow', {
      EventName: "".concat(event === null || event === void 0 ? void 0 : event.title)
    });
    winnreAuth({
      method: 'POST',
      url: "winnre/user/events/register?eventId=".concat(event === null || event === void 0 ? void 0 : event.id, "&userId=").concat(userId, "&sourcePlatform=").concat(clickThroughMobile ? 'MOBILE' : 'WEBSITE')
    }).then(function () {
      if (!(event !== null && event !== void 0 && event.registerationUrl)) {
        setIsRegistered(true);
        setShowRegisteredModal(true);
      }
    })["catch"](function () {});
    if (event !== null && event !== void 0 && event.registerationUrl && !showUnregisteredModal) {
      window.open(event === null || event === void 0 ? void 0 : event.registerationUrl);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "\n                    ".concat(config === null || config === void 0 ? void 0 : config.bannerNegativeTopMarginClass, " w-full h-auto "),
      children: [isLoading && /*#__PURE__*/_jsxs("div", {
        className: "h-screen",
        children: [' ', /*#__PURE__*/_jsx(LoadingSpinner, {})]
      }), !isLoading && /*#__PURE__*/_jsxs("div", {
        className: "relative w-full  lg:sticky lg:top-0 h-full",
        children: [/*#__PURE__*/_jsx("img", {
          src: event === null || event === void 0 || (_event$displayImage = event.displayImage) === null || _event$displayImage === void 0 ? void 0 : _event$displayImage.url,
          className: " w-full h-full object-scale-down"
        }), /*#__PURE__*/_jsx("div", {
          onClick: function onClick() {
            return history.goBack();
          },
          className: "absolute flex justify-center items-center top-2 left-2 rounded-full h-10 w-10 bg-[#ffffffb3]",
          children: /*#__PURE__*/_jsx(BsArrowLeft, {
            className: "text-black w-6 h-full cursor-pointer"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Container, {
      className: ' min-h-screen w-full',
      config: config,
      children: /*#__PURE__*/_jsxs("main", {
        className: "z-10 min-h-full flex flex-col-reverse lg:pt-5 lg:flex-row -mt-6",
        children: [/*#__PURE__*/_jsxs("section", {
          className: "z-10 w-full lg:w-[70%] pl-4 pr-4 xl:pl-16 xl:pr-16 2xl:pl-20 2xl:pr-20 pb-10",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "".concat(config === null || config === void 0 ? void 0 : config.blogs.detailsPageBackgroundColor) + ' md:px-4 py-6',
            children: [/*#__PURE__*/_jsx("h1", {
              className: "font-bold ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe = config.deals.darkTheme) === null || _config$deals$darkThe === void 0 ? void 0 : _config$deals$darkThe.text) || 'text-[#9b9b9b]' : 'text-black', " uppercase pb-4 text-xl xl:text-2xl  ").concat(config === null || config === void 0 || (_config$events = config.events) === null || _config$events === void 0 ? void 0 : _config$events.fontHeading),
              children: event === null || event === void 0 ? void 0 : event.title
            }), /*#__PURE__*/_jsx("div", {
              dangerouslySetInnerHTML: {
                __html: event === null || event === void 0 ? void 0 : event.description
              },
              className: "min-h-full text-base  ".concat(config !== null && config !== void 0 && config.darkMode ? (config === null || config === void 0 || (_config$deals$darkThe2 = config.deals.darkTheme) === null || _config$deals$darkThe2 === void 0 ? void 0 : _config$deals$darkThe2.text) || 'text-[#9b9b9b]' : 'text-black', " ")
            }), /*#__PURE__*/_jsx("button", {
              className: 'mt-4 disabled:bg-gray-200 disabled:text-white -ml-1 ' + (config === null || config === void 0 ? void 0 : config.clientButtonClassName),
              disabled: isRegistered,
              onClick: registerHandler,
              children: isRegistered ? 'REGISTERED' : 'REGISTER NOW'
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "md:px-4 flex flex-col-reverse xl:flex-row justify-between",
            children: /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("p", {
                className: " self-center text-sm text-primary",
                children: "If you like the event, please feel free to share"
              }), /*#__PURE__*/_jsxs("div", {
                className: "mt-1",
                children: [/*#__PURE__*/_jsx(WhatsappShareButton, {
                  url: window.location.href,
                  children: /*#__PURE__*/_jsx(WhatsappIcon, {
                    size: 30
                  })
                }), /*#__PURE__*/_jsx(FacebookShareButton, {
                  url: window.location.href,
                  children: /*#__PURE__*/_jsx(FacebookIcon, {
                    size: 30
                  })
                }), /*#__PURE__*/_jsx(LinkedinShareButton, {
                  url: window.location.href,
                  children: /*#__PURE__*/_jsx(LinkedinIcon, {
                    size: 30
                  })
                }), /*#__PURE__*/_jsx(EmailShareButton, {
                  url: window.location.href,
                  children: /*#__PURE__*/_jsx(EmailIcon, {
                    size: 30
                  })
                }), /*#__PURE__*/_jsx(TwitterShareButton, {
                  url: window.location.href,
                  children: /*#__PURE__*/_jsx("svg", {
                    size: 30,
                    className: "w-7 text-black",
                    stroke: "currentColor",
                    fill: "currentColor",
                    "stroke-width": "0",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/_jsx("path", {
                      d: "M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"
                    })
                  })
                })]
              })]
            })
          })]
        }), /*#__PURE__*/_jsx("section", {
          className: "z-10 flex-col w-full mb-7 lg:mb-0 lg:w-[30%] ",
          children: Sidebar && /*#__PURE__*/_jsx(Sidebar, {
            pastEvents: pastEvents,
            isLoadingEvents: isLoadingEvents,
            showPastEvents: true,
            showSearch: false,
            showRecentBlogs: false,
            showCategories: false,
            config: config
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Modal, {
      className: "w-[95%] md:w-[55%] lg:w-[50%] xl:w-[45%]",
      visible: showUnregisteredModal,
      onClick: function onClick() {
        return setShowUnregisteredModal(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowUnregisteredModal(false);
          },
          className: " h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left px-4 pb-8",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "font-bold text-xl",
          children: "Hello There"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm lg:text-base font-medium mt-2",
          children: "Your registration is being reviewed."
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm lg:text-base font-medium mt-1",
          children: "Your account is currently under review. Once approved, you'll be able to register for events and enjoy all the benefits we offer."
        })]
      })]
    }), /*#__PURE__*/_jsxs(Modal, {
      className: "w-[95%] md:w-[55%] lg:w-[50%] xl:w-[45%]",
      visible: showRegisteredModal,
      onClick: function onClick() {
        return setShowRegisteredModal(false);
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex justify-end mr-4 mt-4",
        children: /*#__PURE__*/_jsx(GrClose, {
          onClick: function onClick() {
            return setShowRegisteredModal(false);
          },
          className: " h-4 w-4 cursor-pointer self-end ml-auto"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "text-left px-4 pb-8",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "font-bold text-xl",
          children: "Registration Successful"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm lg:text-base font-medium mt-2",
          children: "You have successfully registered for this event."
        })]
      })]
    })]
  });
};
export default EventsDetails;